import React from "react";

const HeadingText = ({ className = "", children, tag = "h1", onClick }) => {
  return React.createElement(
    tag,
    { className: `p-0 m-0 ${className}`, onClick },
    children
  );
};

export default HeadingText;

//usage example
//<HeadingText tag="h3"></HeadingText>